var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("e-sidebar", {
        attrs: {
          title: _vm.edit
            ? _vm.$t("Editar Tabela de Preço")
            : _vm.$t("Nova Tabela de Preço"),
          show: _vm.showSidebar,
          fetching: _vm.fetching,
          saving: _vm.saving,
          width: "500px",
        },
        on: { save: _vm.savePriceTable, hidden: _vm.cleanSidebar },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "FormulateForm",
                      {
                        ref: "form",
                        attrs: { name: "form" },
                        on: { submit: _vm.savePriceTable },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "price-table-name",
                                    "is-edit": false,
                                    type: "text",
                                    validation: "required",
                                    label: _vm.$t("Nome"),
                                  },
                                  model: {
                                    value: _vm.localPriceTable.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.localPriceTable, "name", $$v)
                                    },
                                    expression: "localPriceTable.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "price-table-retail-discount",
                                    "is-edit": false,
                                    type: "text-percetage",
                                    "currency-symbol-position": "suffix",
                                    currency: "%",
                                    precision: 4,
                                    label: _vm.$t("Desconto"),
                                    instructions: [
                                      {
                                        text: _vm.$t(
                                          "PRICE_TABLE.INSTRUCTIONS.RETAIL_DISCOUNT"
                                        ),
                                      },
                                    ],
                                  },
                                  model: {
                                    value: _vm.localPriceTable.retailDiscount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.localPriceTable,
                                        "retailDiscount",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "localPriceTable.retailDiscount",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "price-table-echope-classification",
                                    type: "vue-select",
                                    validation: "required",
                                    clearable: false,
                                    label: _vm.$t("Classificação echope"),
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.echopeClassificationOptions(),
                                    instruction: _vm.$t(
                                      "Classificação aplicada automaticamente às vendas feitas nesta tabela, em todos os canais"
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.localPriceTable.echopeClassification,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.localPriceTable,
                                        "echopeClassification",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "localPriceTable.echopeClassification",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "price-table-active-online",
                                    type: "switch",
                                    label: _vm.$t("Ativo Online?"),
                                    instruction: _vm.$t(
                                      "Quando selecionado, esta tabela será considerada nas vendas pelo App e Site"
                                    ),
                                  },
                                  model: {
                                    value: _vm.localPriceTable.activeOnline,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.localPriceTable,
                                        "activeOnline",
                                        $$v
                                      )
                                    },
                                    expression: "localPriceTable.activeOnline",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "price-table-active-online-b2b",
                                    type: "switch",
                                    label: _vm.$t("Ativo Online B2B?"),
                                    instruction: _vm.$t(
                                      "Quando selecionado, esta tabela será considerada nas vendas pelo App B2B"
                                    ),
                                  },
                                  model: {
                                    value: _vm.localPriceTable.activeOnlineB2b,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.localPriceTable,
                                        "activeOnlineB2b",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "localPriceTable.activeOnlineB2b",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "price-table-active-atm",
                                    type: "switch",
                                    label: _vm.$t("Ativo ATM?"),
                                    instruction: _vm.$t(
                                      "Quando selecionado, esta tabela será considerada nas vendas pelos caixas ATM"
                                    ),
                                  },
                                  model: {
                                    value: _vm.localPriceTable.activeAtm,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.localPriceTable,
                                        "activeAtm",
                                        $$v
                                      )
                                    },
                                    expression: "localPriceTable.activeAtm",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }